const machine_txt = {
    type: "VA-0303D",
    name: "Direct Dirve Model Top and Bottom Feed Machine",
    description: [
        "Heighten design in rear cover and cover axis design to avoid oil leakage and operating more safely.",
        "Adopt the Innovative direct drive, energy-saving servo motor directly connect to the main shaft, start fast and stop accurately, reducing the responsive time.",
        "750W energy-saving servo motor, more powerful trimmer. Round knives,high-performance trimmer structural to ensure accurate trimming effect, the cut is flat.",
        "Have the functions of automatic trimmer, automatic needle positioning,automatic counting and automatic reverse sewing.",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/19/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/19/machine_other/1.png",
        "/assets/machine/19/machine_other/2.png",
    ]
}
export default {machine_txt}